import React, { useRef, useState } from "react";
import { CloseIcon, UploadIcon } from "../Assets/iconshere";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Player, BigPlayButton } from "video-react";
import AssetViewer from "./AssetViewer";

const fileTypes = {
  image: ["image/*"],
  video: ["video/*"],
  pdf: [".pdf"],
  model: ["gltf", "glb"],
};

const DynamicUploadBox = ({ userId, fileType, item, updateItem, index }) => {
  const myFileRef = useRef(null);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  var [uploading, setUploading] = useState(false);
  var [error, setError] = useState(null);

  const dropAreaRef = useRef(null);

  const handleProcessing = (action) => {
    if (action) {
      setUploading(true);
    } else {
      setUploading(false);
    }
  };

  const handleFileChange = async (event) => {
    setError(null);
    const files = event.target.files[0];
    const extensions = files.name.split(".").splice(1);
    myFileRef.current.value = null;
    if (extensions.length > 1) {
      setError("invalid file format");
      setTimeout(() => {
        setError(null);
      }, 2500);
      return;
    }
    handleProcessing(true);

    const types =
      fileType === "pdf"
        ? files?.type.split("/")[1]
        : fileType === "model" && fileTypes[fileType].includes(files?.name.split(".").pop())
        ? fileType
        : files?.type.split("/")[0];

    if (types === fileType) {
      const formData = new FormData();
      formData.append("file", files);
      try {
        const { data } = await axios.post(
          `${configData.config.UNO_URL}/api/resource/environment/upload/dynamic/${fileType}/${userId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData?.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        var newItem = { url: data.url };
        updateItem(fileType, index, newItem);
        handleProcessing(false);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    handleFileChange({ target: { files } });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnter = () => {
    dropAreaRef.current.classList.add("drag-over");
  };

  const handleDragLeave = () => {
    dropAreaRef.current.classList.remove("drag-over");
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  return (
    <>
      {item?.url ? (
        <div className="upload-box">
          <div className="dropandselect">
            {fileType === "image" && (
              <label htmlFor="fileUpload">
                <img src={item.url} alt="Preview" referrerPolicy={"no-referrer"} />
              </label>
            )}
            {fileType === "video" && (
              <label onContextMenu={handleContextMenu}>
                <Player>
                  <source src={item.url} />
                  <BigPlayButton position="center" />
                </Player>
              </label>
            )}
            {fileType === "pdf" && (
              <label htmlFor="fileUpload">
                <iframe src={item.url} title="PDF Preview"></iframe>
              </label>
            )}
            {fileType === "model" && <AssetViewer theeDAssetFile={item.url} />}
            {userData.user.permissions.includes("METAVERSE.DYNAMIC.CONTENT") && (
              <span
                className="canceldelete"
                onClick={() => updateItem(fileType, index, { url: null })}
                style={{ cursor: "pointer", lineHeight: "1" }}
              >
                <CloseIcon />
              </span>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className="upload-box">
            {error && <p className="errorMessage"> {error}</p>}
            <div
              ref={dropAreaRef}
              className="dropandselect"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragEnter={handleDragEnter}
              onDragLeave={handleDragLeave}
            >
              <label htmlFor="fileUpload">
                <UploadIcon />
                <p>
                  Drag & Drop or <span> Choose file </span> to upload
                </p>
                <input
                  ref={myFileRef}
                  type="file"
                  id="fileUpload"
                  name="fileUpload"
                  onChange={handleFileChange}
                  accept={fileTypes[fileType]}
                />
              </label>
            </div>
          </div>
          {uploading && (
            <div className="progress" style={{ height: "auto" }}>
              <div className="uploadProgressBar w-100">
                <div className="progress    " style={{ height: "10px" }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "100%", height: "10px" }}
                  ></div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DynamicUploadBox;
